import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ReViewTakeMoney from "./ReViewTakeMoney";
import {
  change_Lang,
  EveryTimeTo_English,
} from "../../../actions/Helper_action";
import {
  Take_Money_View,
  Update_TakeMoney,
} from "../../../actions/Invoice_action";
import { Get_List_Agents } from "../../../actions/Agent_action";
export class ReView_TakeMoney extends Component {
  render() {
    const {
      parawargrtn_view,
      lang,
      change_Lang,
      Update_TakeMoney,
      EveryTimeTo_English,
      index_all_takemoney,
      Get_List_Agents,
      list_agents,
      handleCancel,
    } = this.props;
    return (
      <Fragment>
        <div className="container-fluid">
          <ReViewTakeMoney
            parawargrtn_view={parawargrtn_view}
            lang={lang}
            change_Lang={change_Lang}
            Update_TakeMoney={Update_TakeMoney}
            EveryTimeTo_English={EveryTimeTo_English}
            index_all_takemoney={index_all_takemoney}
            Get_List_Agents={Get_List_Agents}
            list_agents={list_agents}
            handleCancel={handleCancel}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    parawargrtn_view: state.InvoiceReducer.parawargrtn_view,
    list_bills: state.InvoiceReducer.list_bills,
    index_all_takemoney: state.InvoiceReducer.index_all_takemoney,
    list_agents: state.AgentReducer.list_agents,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    EveryTimeTo_English: (keys) => dispatch(EveryTimeTo_English(keys)),
    Update_TakeMoney: (id, data) => dispatch(Update_TakeMoney(id, data)),
    Take_Money_View: (id, index) => dispatch(Take_Money_View(id, index)),
    Get_List_Agents: () => dispatch(Get_List_Agents()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReView_TakeMoney);
